<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items-per-page="5"
            :items="items"
            fixed-header
                height="350"
            >
            <template  v-slot:top>
                <v-row class="child-flex">
                <div>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>
                        รายการเบิกวัสดุสิ้นเปลือง
                    </v-toolbar-title>
                    </v-toolbar>
                </div>
                <v-spacer></v-spacer><v-spacer></v-spacer>
                <div class="mx-2">
                <v-toolbar class="d-flex justify-end" flat color="white">
                        <v-spacer></v-spacer>
                        <DlgWithdrawConsumable 
                            style="mr-0"
                            ref="dlgConsumable"
                            @onCloseDialog="onCloseDialog"
                            @onSaveConsumable="onSaveConsumable"
                            :canEdit="canEdit"
                            :branchCode="branchCode"
                            :items="items">
                        </DlgWithdrawConsumable>

                        <DlgWithdrawConsumableColor
                            ref="dlgColor"
                            @onCloseDialog="onCloseDialog"
                            @onSaveConsumableColor="onSaveColor"
                            :canEdit="canEdit"
                            :branchCode="branchCode"
                            :items="items"></DlgWithdrawConsumableColor>
                        <v-btn color="primary" @click="printReport">รายงานสรุป</v-btn>
                </v-toolbar>
                </div>
                </v-row>
            </template>

            <template v-if="canEdit" v-slot:item.action="{ item }">
                <v-icon
                        small
                        @click="editItem(item)"
                        v-if="!item.jobConsumableId"
                    >
                        edit
                    </v-icon>
                    <v-icon
                        small
                        @click="deleteItem(item)"
                        v-if="!item.jobConsumableId"
                    >
                        delete
                    </v-icon>
                    <v-icon
                        small
                        @click="cancelItem(item)"
                        v-if="item.jobConsumableId && !item.cancel"
                    >
                        block
                    </v-icon>
                    <span style="margin-left: 10px;" >
                    <v-tooltip v-if="item.formular" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click="printConsumableColor(item)"
                    >
                        print
                    </v-icon> &nbsp;
                    </template>
                    <span>พิมพ์วัสดุสิ้นเปลืองสี</span>
                    </v-tooltip>
                    </span>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import rules from '@/assets/js/rules.js'
import DlgWithdrawConsumable from './DlgWithdrawConsumable'
import DlgWithdrawConsumableColor from './DlgWithdrawConsumableColor'
import {printConsumableByJob,printConsumableColorByJob} from '@/api/job/job-api.js'
import numeral from 'numeral'
import dialog from '@/assets/js/dialog.js'

export default {
    name: 'Tab3',
    components: {
        DlgWithdrawConsumable,
        DlgWithdrawConsumableColor
    },
    props: ["branchCode", "jobConsumable", "canEdit","jobId","job"],
    data: () => ({
        validDetail: false,
        rules: rules,
        headers: [
            {text: 'No.', value: 'no'},
            {text: 'รหัสวัสดุ', value: 'consumableCode'},
            {text: 'ชื่อวัสดุสิ้นเปลือง', value: 'consumableName'},
            {text: 'ประเภท', value: 'consumableTypeText'},
            {text: 'จำนวน', value: 'qty'},
            {text: 'ช่าง', value: 'withdrawBy'},
            {text: 'วันที่เบิก', value: 'withdrawDate'},
            {text: 'ยอดรวม', value: 'total'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        items: [],
        editedItem: {
            consumableId: '',
            consumableCode: '',
            consumableName: '',
            consumableType: '',
            qty: 1,
            withdrawBy: '',
            withdrawDate: '',
            total: 0,
            cancel: false,
            colors: []
        },
        defaultItem: {
            consumableId: '',
            consumableCode: '',
            consumableName: '',
            consumableType: '',
            qty: 1,
            withdrawBy: '',
            withdrawDate: '',
            total: 0,
            cancel: false,
            colors: []
        },
        editedIndex: -1
    }),
    methods: {
        cancelItem(item) {
            if (!confirm("ต้องการยกเลิกรายการใช่หรือไม่")) return;
            item.cancel = true;
        },
        editItem(item) {
            this.editedItem = Object.assign({}, item);
            this.editedIndex = this.items.indexOf(item);
            if (item.kind === '1') {
                this.$refs.dlgConsumable.show(this.editedItem);
            } else {
                this.editedItem.colors = item.colors;
                this.$refs.dlgColor.show(this.editedItem);
            }
        },
        deleteItem(item) {
            if (!confirm("ต้องการลบข้อมูลใช่หรือไม่")) return;
            let index = this.items.indexOf(item);
            this.items.splice(index, 1);
            this.$emit("edited", true);
        },
        onSaveConsumable(item) {
            let recentItem = this.items.filter(o => o.consumableCode === item.consumableCode && !o.jobConsumableId);
            if (recentItem && recentItem.length > 0) {
                let newQty = parseFloat(recentItem[0].qty) + parseFloat(item.qty);
                if (newQty > parseFloat(item.stockRemain)) {
                    dialog.warn("จำนวนที่เบิกวัสดุสิ้นเปลืองรวมแล้วเกินจำนวนที่มีอยุ่ในระบบ กรุณาเพิ่มรายการใหม่");
                    return;
                }

                recentItem[0].qty = newQty;
                recentItem[0].withdrawBy = item.withdrawBy;
                Object.assign(this.items[this.editedIndex], item);
                this.editedIndex = -1;
                this.$emit("edited", true);
                return;
            }
            item.kind = '1';
            item.total = numeral(item.qty * item.unitPrice).format('0.00');
            if (this.editedIndex > -1) {
                Object.assign(this.items[this.editedIndex], item);
            } else {
                item.no = this.items.length + 1;
                //item.consumableTypeText = 'วัสดุสำนักงาน';
                 this.items.push(item);
            }
            this.editedIndex = -1;
            this.$emit("edited", true);
        },
        onSaveColor(item) {
            item.kind = '2';
            item.total = numeral(item.qty * item.unitPrice).format('0.00');
            if (this.editedIndex > -1) {
                Object.assign(this.items[this.editedIndex], item);
            } else {
                item.no = this.items.length + 1;
                //item.consumableTypeText = 'สี';
                this.items.push(item);
            }
            this.editedIndex = -1;
           this.$emit("edited", true);
        },
        onCloseDialog() {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        },
        printReport(){
            printConsumableByJob(this.jobId,this.job.jobNo);
        },
        printConsumableColor(item){
            printConsumableColorByJob(item.jobConsumableId,item.consumableCode,this.jobId);
        }
        
    },
    mounted() {
        if (this.jobConsumable) {
            this.items = this.jobConsumable;
            if (this.items && this.items.length > 0) {
                this.items.forEach(o => {
                    o.total = numeral(o.qty * o.unitPrice).format('0.00');
                })
            }
        }
    }
}
</script>